__turbopack_context__.v({
  "className": "montserrat_56fadfee-module__aag_La__className",
});
